import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GrapesJsEditorBlocksService {
  addGrapesJsManualBlocks(blockManager) {
    // Header Block
    blockManager.add('header', {
      label: 'Header',
      media: `<svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M4 4H20V6H4V4M4 10H20V12H4V10M4 16H12V18H4V16Z" />
          </svg>`,
      content: `
          <div>
            <header class="header">
              <a href="/" class="header-logo">
                <span class="header-title">Simple header</span>
              </a>

              <nav class="header-nav">
                <ul class="nav-list">
                  <li class="nav-item"><a href="#" class="nav-link active" aria-current="page">Home</a></li>
                  <li class="nav-item"><a href="#" class="nav-link">Features</a></li>
                  <li class="nav-item"><a href="#" class="nav-link">Pricing</a></li>
                  <li class="nav-item"><a href="#" class="nav-link">FAQs</a></li>
                  <li class="nav-item"><a href="#" class="nav-link">About</a></li>
                </ul>
              </nav>
            </header>
          </div>

          <style>

            .header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 2px solid #ddd;
              padding: 20px 0;
            }

            .header-logo {
              display: flex;
              align-items: center;
              text-decoration: none;
              padding-left:12px;
            }

            .header-logo svg {
              margin-right: 10px;
            }

            .header-title {
              font-size: 24px;
              font-weight: bold;
              color: #333;
            }

            .header-nav {
              margin-left: auto;
              background:unset;
            }

            .nav-list {
              display: flex;
              gap: 15px;
              list-style: none;
              padding: 0;
            }

            .nav-item {
              display: inline;
            }

            .nav-link {
              text-decoration: none;
              color: #333;
              font-size: 16px;
            }

            .nav-link.active {
              font-weight: bold;
              color: #007bff;
            }

            .nav-link:hover {
              text-decoration: underline;
            }
          </style>
        `,
    });

    blockManager.add('button', {
      label: 'Button',
      media: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M20 20.5C20 21.3 19.3 22 18.5 22H13C12.6 22 12.3 21.9 12 21.6L8 17.4L8.7 16.6C8.9 16.4 9.2 16.3 9.5 16.3H9.7L12 18V9C12 8.4 12.4 8 13 8S14 8.4 14 9V13.5L15.2 13.6L19.1 15.8C19.6 16 20 16.6 20 17.1V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H8V12H4V4H20V12H18V14H20C21.1 14 22 13.1 22 12V4C22 2.9 21.1 2 20 2Z" />
      </svg>`,
      content: '<a class="button">Button</a>',
    });

    blockManager.add('divider', {
      label: 'Divider',
      media: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
      </svg>`,
      content: `
        <table style="width: 100%; margin-top: 10px; margin-bottom: 10px;">
          <tr>
            <td class="divider"></td>
          </tr>
        </table>
        <style>
          .divider {
            background-color: rgba(0, 0, 0, 0.1);
            height: 1px;
          }
        </style>
      `,
    });

    blockManager.add('text-sect', {
      label: 'Text Section',
      media: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z" />
      </svg>`,
      content: `
        <h1 class="heading">Insert title here</h1>
        <p class="paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      `,
    });

    const gridItem = `<table class="grid-item-card">
      <tr>
        <td class="grid-item-card-cell">
          <img class="grid-item-image" src="https://via.placeholder.com/250x150/78c5d6/fff/" alt="Image"/>
          <table class="grid-item-card-body">
            <tr>
              <td class="grid-item-card-content">
                <h1 class="card-title">Title here</h1>
                <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>`;

    blockManager.add('grid-items', {
      label: 'Grid Items',
      media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3"/>
    </svg>`,
      content: `
      <table class="grid-item-row">
        <tr>
          <td class="grid-item-cell2-l">${gridItem}</td>
          <td class="grid-item-cell2-r">${gridItem}</td>
        </tr>
      </table>
    `,
    });

    // Card
    blockManager.add('card', {
      label: 'Card',
      media: `<svg viewBox="0 0 24 24">
                <path fill="currentColor" d="M4 4H20V20H4V4M6 6V18H18V6H6M8 8H16V10H8V8M8 12H16V14H8V12M8 16H12V18H8V16Z"/>
              </svg>`,
      content: `
        <div class="custom-card" style="background-color: #fff;width: 18rem; border: 1px solid #ddd; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); text-align: center;">
          <img src="..." class="custom-card-img" alt="Card image" style="width: 120px; height: auto;">
          <div class="custom-card-body" style="padding: 15px;">
            <h5 class="custom-card-title" style="font-size: 1.25rem; margin: 0;">Card title</h5>
            <p class="custom-card-text" style="font-size: 1rem; color: #555;">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            <a href="#" class="custom-btn" style="display: inline-block; padding: 8px 16px; background-color: #007bff; color: white; text-decoration: none; border-radius: 4px;">Go somewhere</a>
          </div>
        </div>
      `,
    });

    // Alert
    blockManager.add('alert', {
      label: 'Alert',
      media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M11 15H13V17H11V15M11 7H13V13H11V7M1 21H23L12 2L1 21Z"/>
    </svg>`,
      content: `
      <div class="alert">
        <strong>Warning!</strong> This is an alert message.
      </div>
      <style>
        .alert {
          padding: 15px;
          background-color: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 4px;
          margin: 10px 0;
        }
      </style>
    `,
    });

    const listItem = `<table class="list-item">
      <tr>
        <td class="list-item-cell">
          <table class="list-item-content">
            <tr class="list-item-row">
              <td class="list-cell-left">
                <img class="list-item-image" src="https://via.placeholder.com/150/78c5d6/fff" alt="Image"/>
              </td>
              <td class="list-cell-right">
                <h1 class="card-title">Title here</h1>
                <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>`;

    blockManager.add('list-items', {
      label: 'List Items',
      media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M2 14H8V20H2M16 8H10V10H16M2 10H8V4H2M10 4V6H22V4M10 20H16V18H10M10 16H22V14H10"/>
    </svg>`,
      content: listItem + listItem,
    });

    // Footer Block
    blockManager.add('footer', {
      label: 'Footer',
      media: `<svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M4 4H20V6H4V4M4 10H20V12H4V10M4 16H12V18H4V16Z" />
          </svg>`,
      content: `
        <div class="container">
          <footer class="footer">
            <ul class="footer-nav">
              <li><a href="#">Home</a></li>
              <li><a href="#">Features</a></li>
              <li><a href="#">Pricing</a></li>
              <li><a href="#">FAQs</a></li>
              <li><a href="#">About</a></li>
            </ul>
            <p class="footer-text">© 2025 Company, Inc</p>
          </footer>
        </div>
        <style>
          .footer {
            padding: 20px 0;
            text-align: center;
            background: #f8f9fa;
            border-top: 1px solid #ddd;
            margin-top: 40px;
          }

          .footer-nav {
            list-style: none;
            padding: 0;
            margin: 0 0 10px;
            display: flex;
            justify-content: center;
            gap: 15px;
          }

          .footer-nav li {
            display: inline;
          }

          .footer-nav a {
            text-decoration: none;
            color: #6c757d;
            font-size: 14px;
            transition: color 0.3s ease;
          }

          .footer-nav a:hover {
            color: #007bff;
          }

          .footer-text {
            font-size: 14px;
            color: #6c757d;
            margin: 0;
          }
        </style>
      `,
    });
  }

  //#endregion
}
